import {WCR_COMPANY_ABBREVIATIONS} from "../constants";

const getWCRShortName = (input) => {
    if (!isNaN(input)) {
        const company = WCR_COMPANY_ABBREVIATIONS[input];
        if (company) {
            return company.shortName;
        }
    } else {
        for (const key in WCR_COMPANY_ABBREVIATIONS) {
            const company = WCR_COMPANY_ABBREVIATIONS[key];
            if ((company.name && company.name.toLowerCase() === input.toLowerCase()) ||
                (company.key && company.key.toLowerCase() === input.toLowerCase())) {
                return company.shortName;
            }
        }
    }
    return undefined;
}

export default getWCRShortName;